<template>
    <BCard v-if="classroom">
        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <TextInputValidated vsName="Name" :vsModel.sync="classroom.name" vsLabel="name" vsMd="6" vsRequired vsRules="required"/>
                    <NumberInputValidated vsName="Places" :vsModel.sync="classroom.places" vsLabel="places" vsMd="6" />
                    <vSelectValidated v-if="groups && groups.length>1" vsName="Group" :vsModel.sync="classroom.group_id" :vsOptions="groups" :vsReduce="gr=>gr.id" vsLabel="name" vsMd="6" vsRequired vsRules="required"/>
                    <TextareaValidated vsName="Observations" :vsModel.sync="classroom.observations"/>
                </BRow>

                <!-- Action Buttons -->
                <BButton variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'classrooms' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BAlert, BCard, BButton, BForm, BRow, BCol, BFormInvalidFeedback, BFormTextarea, BFormInput, BFormGroup } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { onUnmounted, ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import classroomModule from '../classroomModule'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import router from '@/router'
import store from '@/store'
import { getGroups } from '@/composables/groupService';
export default {
    components: { BAlert, BCard, BButton, BForm, BRow, BCol, BFormInvalidFeedback, BFormTextarea, BFormInput, BFormGroup, vSelect, TextInputValidated, TextareaValidated, vSelectValidated, ValidationObserver, ValidationProvider, NumberInputValidated },
    setup(){
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const CLASSROOM_MODULE = 'classrooms'
        const classroom = ref(null)
        const groups = ref([])

        const onSubmit = function() {
            this.$refs.form.validate().then(success => {
                if(success) {
                    store.dispatch('classrooms/updateClassroom', JSON.parse(JSON.stringify(classroom.value)))
                        .then(response => { this.$router.push({ name: 'classrooms' }) })
                        .catch(error => { errorToast('Can\'t update classrooms') })
                }
            })
        }

        if (!store.hasModule(CLASSROOM_MODULE)) store.registerModule(CLASSROOM_MODULE, classroomModule)

        onUnmounted(() => {
            if (store.hasModule(CLASSROOM_MODULE)) store.unregisterModule(CLASSROOM_MODULE)
        })

        store.dispatch('classrooms/fetchClassroom', { id: router.currentRoute.params.id }).then(response => {
            classroom.value = response.data.classroom
        })

        const fetchGroups = async function () { groups.value = (await getGroups()).data.groups }        
        fetchGroups()


        return {
            getValidationState,
            onSubmit,
            classroom,
            groups
        }
    }
}
</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
</style>
